import axios from "../../../lib/axios";
import { ObjectID } from "bson";

let autoSaveTimer;

export const setDirty = ({ commit }, dirty) => {
  commit("SET_DIRTY", dirty);
};

export const setInSync = ({ commit }, inSync) => {
  commit("SET_INSYNC", inSync);
  if (inSync) commit("SET_DIRTY", false);
};

export const setUpdatedAt = ({ commit }, updatedAt) => {
  commit("SET_UPDATED_AT", updatedAt);
};

export const autoSave = ({ commit, state }) => {
  if (state.current._id === undefined) return;
  if (state.dirty === true) return;

  setInSync({ commit }, true);
  setDirty({ commit }, true);
  clearTimeout(autoSaveTimer);
  autoSaveTimer = setTimeout(function() {
    setInSync({ commit }, false);
  }, 2000);
};

export const all = async ({ commit }, payload) => {
  try {
    payload = payload || {};
    let params = payload.params || "sort=name";
    let res = await axios.get(`/characters?${params}`);
    commit("SET_ALL", res.data);
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const create = async ({ commit }, payload) => {
  try {
    let res = await axios.post(`/characters`, payload);
    commit("CREATE", res.data);
    return res.data;
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const read = async ({ commit, state }, payload) => {
  let local = state.all.find(x => x._id === payload.id);
  commit("SET_ITEM", local);

  // get latest
  try {
    let res = await axios.get(`/characters/${payload.id}`);
    commit("SET_ITEM", res.data);
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const edit = async ({ commit, state }, payload) => {
  let local = state.all.find(x => x._id === payload.id);

  let localUpdated = local
    ? new Date(local.updatedAt).getTime()
    : new Date().getTime();
  let currentUpdated = new Date(state.current.updatedAt).getTime();

  if (currentUpdated !== localUpdated) {
    commit("SET_ITEM", local);
  }

  // get latest
  try {
    let res = await axios.get(`/characters/${payload.id}/edit`);
    if (res.data.updatedAt !== localUpdated) {
      commit("SET_ITEM", res.data);
    }
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const update = async ({ commit, state }) => {
  try {
    let res = await axios.patch(
      `/characters/${state.current._id}`,
      state.current
    );
    commit("UPDATE", res.data);
    commit("SET_ITEM", res.data);
    setInSync({ commit }, true);
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const clone = async ({ commit, state }) => {
  try {
    let clone = JSON.parse(JSON.stringify(state.current));
    delete clone._id;
    if (clone.name) {
      clone.name = `${clone.name} (Copy)`;
    }
    let res = await axios.post(`/characters`, clone);
    commit("CREATE", res.data);
    return res.data;
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const destroy = async ({ commit, state }) => {
  try {
    await axios.delete(`/characters/${state.current._id}`);
    commit("DELETE", state.current);
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

/* ARRAY ITEMS */
export const createItem = async ({ commit, state, rootState }, payload) => {
  let schemaType = [
    "skills",
    "actions",
    "notes",
    "spells",
    "trackables",
    "items",
    "proficiencies"
  ].includes(payload.section)
    ? payload.section
    : "rules";
  let schema = rootState.schemas[schemaType].find(
    s => s.ruleset === state.current.ruleset
  ).schema;
  let item = JSON.parse(JSON.stringify(schema));

  if (payload.data) {
    Object.assign(item, payload.data);
  }

  item._id = new ObjectID().toString();

  payload.item = item;
  commit("CREATE_ITEM", payload);
  await update({ commit, state });
  return item;
};

export const cloneItem = async ({ commit, state }, payload) => {
  let item = JSON.parse(JSON.stringify(payload.clone));
  item._id = new ObjectID().toString();
  if (item.name) {
    item.name = `${item.name} (Copy)`;
  }
  let clone = {
    section: payload.section,
    item: item
  };
  commit("CREATE_ITEM", clone);
  await update({ commit, state });
  return clone.item;
};

export const deleteItem = async ({ commit, state }, payload) => {
  commit("DELETE_ITEM", payload);
  await update({ commit, state });
};
